var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRgBlightSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.242,
    height: 23.999,
    viewBox: "0 0 16.242 23.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RGB_light_Settings",
    "data-name": "RGB light Settings",
    transform: "translate(-1867.148 -95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9397",
    "data-name": "Path 9397",
    d: "M11810.719,1200.1a1.021,1.021,0,0,1-1.019-1.021v-4.38h2.038v4.38A1.021,1.021,0,0,1,11810.719,1200.1Zm-4.8-1.2a1.022,1.022,0,0,1-1.021-1.021V1194.7h2.041v3.178A1.022,1.022,0,0,1,11805.919,1198.9Zm7.079-3.6h-9.6a.9.9,0,0,1-.9-.9v-7.2a5.7,5.7,0,1,1,11.4,0v7.2A.9.9,0,0,1,11813,1195.3Zm-4.8-11.76a3.666,3.666,0,0,0-3.66,3.664v6.058h7.321V1187.2A3.666,3.666,0,0,0,11808.2,1183.538Zm1.942,4.2h-.015a.3.3,0,0,1-.3-.288,2.362,2.362,0,0,0-.447-1.256,2.307,2.307,0,0,0-1.161-.6.3.3,0,0,1-.244-.349.3.3,0,0,1,.294-.245.28.28,0,0,1,.055,0,2.4,2.4,0,0,1,2.1,2.413A.307.307,0,0,1,11810.142,1187.743Z",
    transform: "translate(-9932.93 -1081.101)",
    fill: "#909395"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9395",
    "data-name": "Path 9395",
    d: "M1.2,0A1.2,1.2,0,0,1,2.4,1.2V2.4A1.2,1.2,0,1,1,0,2.4V1.2A1.2,1.2,0,0,1,1.2,0Z",
    transform: "translate(1874.069 95)",
    fill: "#0da505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9396",
    "data-name": "Path 9396",
    d: "M1.2,0A1.2,1.2,0,0,1,2.4,1.2V2.4A1.2,1.2,0,1,1,0,2.4V1.2A1.2,1.2,0,0,1,1.2,0Z",
    transform: "translate(1881.693 96.8) rotate(45)",
    fill: "#3009f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9394",
    "data-name": "Path 9394",
    d: "M1.2,0A1.2,1.2,0,0,1,2.4,1.2V2.4A1.2,1.2,0,1,1,0,2.4V1.2A1.2,1.2,0,0,1,1.2,0Z",
    transform: "translate(1871.391 99.345) rotate(135)",
    fill: "#f0171c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRgBlightSettings);
export default __webpack_public_path__ + "static/media/RGBlight Settings.3aeb5e4ff6c3d7df4d5b53d4a5ed6954.svg";
export { ForwardRef as ReactComponent };